/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgLifeBuoy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M5.946 5.006l3.266 3.148A4.731 4.731 0 0112 7.25c1.041 0 2.005.336 2.788.904l3.266-3.148A9.212 9.212 0 0012 2.75c-2.315 0-4.431.85-6.054 2.256zm13.159 1.07l-3.257 3.14c.567.781.902 1.744.902 2.784 0 1.04-.335 2.003-.902 2.785l3.257 3.138A9.21 9.21 0 0021.25 12a9.21 9.21 0 00-2.145-5.923zm-1.05 12.918l-3.267-3.148A4.73 4.73 0 0112 16.75a4.73 4.73 0 01-2.788-.904l-3.266 3.148A9.211 9.211 0 0012 21.25c2.315 0 4.431-.85 6.054-2.256zm-13.16-1.07l3.257-3.14A4.731 4.731 0 017.25 12c0-1.04.335-2.003.902-2.785L4.895 6.077A9.21 9.21 0 002.75 12a9.21 9.21 0 002.145 5.923zM4.323 4.474A10.72 10.72 0 0112 1.25a10.72 10.72 0 017.677 3.225A10.718 10.718 0 0122.75 12c0 2.93-1.173 5.587-3.073 7.525A10.72 10.72 0 0112 22.75a10.72 10.72 0 01-7.677-3.225A10.717 10.717 0 011.25 12c0-2.93 1.173-5.587 3.073-7.525zM12 8.75c-.895 0-1.703.36-2.292.946A3.238 3.238 0 008.75 12c0 .9.366 1.715.958 2.304A3.238 3.238 0 0012 15.25c.895 0 1.703-.36 2.292-.946.592-.59.958-1.403.958-2.304 0-.9-.366-1.715-.958-2.304A3.238 3.238 0 0012 8.75z'
      />
    </svg>
  );
}

export default SvgLifeBuoy;
